module.exports = __webpack_public_path__ + "img/logo.f0344e18.png";